import React from 'react'
import { Line } from 'react-chartjs-2'

export default function LineChart({ data, options = {}, ...props }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    elements: {
      line: {
        tension: 0.3
      },
      point: {
        radius: 2,
        hoverRadius: 5
      }
    }
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...options.plugins
    },
    scales: {
      x: { ...defaultOptions.scales.x, ...options.scales?.x },
      y: { ...defaultOptions.scales.y, ...options.scales?.y }
    }
  }

  return <Line data={data} options={mergedOptions} {...props} />
}
